import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { NgForm } from '@angular/forms';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs';
import { GetAllDiamondSizeResponseModel } from 'src/app/components/administration/administration.model';
import { SendDataService } from '../../services/send-data.service';

@Component({
  selector: 'app-diamond-size',
  templateUrl: './diamond-size.component.html',
  styleUrls: ['./diamond-size.component.scss']
})
export class DiamondSizeComponent extends CommonService implements OnInit{
  @ViewChild('administrationFormData') administrationFormData! : NgForm ;
  getAllDiamondSizeData          : any[]=[];

  copyGetAllDiamondSizeData           : any[]=[]
  editDiamondSizeData                = new GetAllDiamondSizeResponseModel();
  isAdd                       : boolean = false;

constructor(
  public renderer:Renderer2,
  public administrationService : AdministrationService,
  public toaster: ToastrService,
  public sendDataService : SendDataService,
) 
{
  super(renderer)
}

ngOnInit(): void {
  this.getAllDiamondSizeList();
}

add(){
  if(!this.sendDataService?.permissionVM?.mastersCanAdd) return; if(!this.sendDataService?.permissionVM?.mastersCanAdd) return;
  this.isAdd = true;
  const obj = {id:0, name:'',active:true}
  this.getAllDiamondSizeData?.push(obj);
  this.copyGetAllDiamondSizeData?.push(obj);
  setTimeout(()=>{
    const element = document.getElementById(`diamondSizeName${obj.id}`);
    element?.focus();
  },0)
}


cancel(){
  if(this.isAdd)
  {
    this.isAdd = false;
    this.getAllDiamondSizeData = this.getAllDiamondSizeData.filter((x)=>x.id != 0);
    this.copyGetAllDiamondSizeData = this.copyGetAllDiamondSizeData.filter((x)=>x.id != 0);
  }
  else if(this.editDiamondSizeData?.id && this.editDiamondSizeData?.isEdit){
    const index = this.copyGetAllDiamondSizeData.findIndex((x)=>x.id == this.editDiamondSizeData?.id);
    const singleData =JSON.parse(JSON.stringify(this.copyGetAllDiamondSizeData))[index];
    this.getAllDiamondSizeData[index] = singleData;
    this.editDiamondSizeData = new GetAllDiamondSizeResponseModel();
  }  
}


edit(item,formData){
  if(!this.sendDataService?.permissionVM?.mastersCanUpdate) return;
  item.isEdit = true;
  const controlObj = formData?.form?.controls;
  if(controlObj){
    const id = Object.keys(controlObj)[0];
    const element = document.getElementById(id);
    element?.focus();
  }
  this.editDiamondSizeData = {...item};
}


checkIsEdit(arr:any[]):boolean{
  return arr?.some((x)=>x.isEdit)
}


  // *********** Diamond-size API START *********
  // **********get all Diamond-size *********
  getAllDiamondSizeList() {
    this.administrationService.getAllDiamondSize().subscribe({
      next:(res)=>{
        if(res.isSuccess){
          this.getAllDiamondSizeData = res.response??[];
          this.editDiamondSizeData = new GetAllDiamondSizeResponseModel();
          this.copyGetAllDiamondSizeData = JSON.parse(JSON.stringify(this.getAllDiamondSizeData))??[];
        }else{           
          this.getAllDiamondSizeData = [];
          this.copyGetAllDiamondSizeData = [];
        }  
      },
      error:(err)=>{
        this.getAllDiamondSizeData = []; 
        this.copyGetAllDiamondSizeData = [];
      }
    })
  }

 // *************insert Diamond-size **************
  InserDiamondSizeList(item) {
    const {id , ...rest} = item;
    this.administrationService.insertDiamondSize(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            this.isAdd = false;
            this.getAllDiamondSizeList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }

  // **********update Diamond-size *********
    UpdateDiamondSizeList(item) {
    const {isEdit , ...rest} = item;
    this.administrationService.updateDiamondSize(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            
            this.isAdd = false;
            this.getAllDiamondSizeList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }  

    // **********delete Diamond-size *********
    DeleteDiamondSizeList(id) {
      if(!this.sendDataService?.permissionVM?.mastersCanDelete) return;
      this.administrationService.deleteDiamondSize(id)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if(res.isSuccess){
              this.getAllDiamondSizeList();
              this.toaster.success(res.message);
            }else{
              this.toaster.error(res.errors[0]);
            }  
      });
    }
  
  // *********** Diamond-size API END *********
}

